import React, { useState } from 'react';
import { View } from 'react-native-web';
import RegularText from '../Text/RegularText';
import Title from '../Text/Title';
import ExpandedText from '../Buttons/ExpandedText';

//= ========================================================================

const ExpandedList = ({
  headline,
  textList,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  return (
    <View style={{ marginBottom: 30 }}>
      <ExpandedText isExpanded={isExpanded} onPress={() => setIsExpanded(!isExpanded)}>
        <Title marginBottom={0} isBold>{headline}</Title>
      </ExpandedText>
      {isExpanded && textList.map((text) => <RegularText>{text}</RegularText>)}
    </View>
  );
};
export default ExpandedList;
